import React from 'react';
export function ErrorRenderer(props) {
  const {
    width = 300,
    height = 150,
    value,
    error,
    ErrorComponent
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width,
      height
    }
  }, /*#__PURE__*/React.createElement(ErrorComponent, {
    width: width,
    height: height,
    value: value,
    error: error
  }));
}
export function DefaultErrorRenderer(props) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: `${props.height}px`,
      textAlign: 'center',
      verticalAlign: 'middle'
    }
  }, props.message);
}
//# sourceMappingURL=ErrorRenderer.js.map